// ===== Supabase Client =====
// غيّر الـ URL والـ Key حسب مشروعك في Supabase

const SUPABASE_URL = "https://YOUR_PROJECT.supabase.co";
const SUPABASE_ANON_KEY = "YOUR_ANON_KEY";

// ===== Helper: Fetch from Supabase REST API =====
async function supaFetch(table, { method = "GET", body, query = "", headers = {} } = {}) {
  const url = `${SUPABASE_URL}/rest/v1/${table}${query}`;
  const opts = {
    method,
    headers: {
      apikey: SUPABASE_ANON_KEY,
      Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
      "Content-Type": "application/json",
      Prefer: method === "POST" ? "return=representation" : method === "PATCH" ? "return=representation" : undefined,
      ...headers,
    },
  };
  if (body) opts.body = JSON.stringify(body);
  // Clean undefined headers
  Object.keys(opts.headers).forEach((k) => {
    if (opts.headers[k] === undefined) delete opts.headers[k];
  });
  const res = await fetch(url, opts);
  if (!res.ok) {
    const err = await res.text();
    throw new Error(`Supabase error (${res.status}): ${err}`);
  }
  const text = await res.text();
  return text ? JSON.parse(text) : null;
}

// ===== CRUD Functions =====

export async function supaGet(table, query = "") {
  return supaFetch(table, { query: query ? `?${query}` : "" });
}

export async function supaInsert(table, data) {
  return supaFetch(table, { method: "POST", body: data });
}

export async function supaUpdate(table, query, data) {
  return supaFetch(table, { method: "PATCH", body: data, query: `?${query}` });
}

export async function supaDelete(table, query) {
  return supaFetch(table, { method: "DELETE", query: `?${query}` });
}

// ===== Auth Functions =====

export async function loginUser(email, passwordHash) {
  const users = await supaGet("users", `email=eq.${encodeURIComponent(email)}&select=*`);
  if (!users || users.length === 0) return { error: "البريد الإلكتروني غير مسجل" };
  const user = users[0];
  if (!user.is_active) return { error: "الحساب معطّل — تواصل مع مدير النظام" };
  if (user.password_hash !== passwordHash) return { error: "كلمة المرور غير صحيحة" };
  // Update last login
  await supaUpdate("users", `id=eq.${user.id}`, { last_login: new Date().toISOString() });
  return { user };
}

export async function getNotifications(userId) {
  return supaGet("notifications", `user_id=eq.${userId}&order=created_at.desc&limit=20`);
}

export async function markNotificationRead(id) {
  return supaUpdate("notifications", `id=eq.${id}`, { is_read: true });
}

export async function getAllUsers() {
  return supaGet("users", "select=*&order=created_at.desc");
}

export async function createUser(userData) {
  return supaInsert("users", userData);
}

export async function toggleUserStatus(userId, isActive) {
  return supaUpdate("users", `id=eq.${userId}`, { is_active: isActive });
}

export async function updatePassword(userId, newHash) {
  return supaUpdate("users", `id=eq.${userId}`, {
    password_hash: newHash,
    must_change_password: false,
  });
}

export async function resetPassword(email, newHash) {
  return supaUpdate("users", `email=eq.${encodeURIComponent(email)}`, {
    password_hash: newHash,
    must_change_password: true,
  });
}

export async function addAuditLog(userId, username, action, details) {
  return supaInsert("audit_log", {
    user_id: userId,
    username,
    action,
    details,
  });
}

export async function addNotification(userId, title, message, type = "info") {
  return supaInsert("notifications", {
    user_id: userId,
    title,
    message,
    type,
    is_read: false,
  });
}
